import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

export type TableSortDirection = 'asc' | 'desc';

export interface TableSortState {
  field: string;
  direction: TableSortDirection;
}

@Component({
  selector: 'lib-table-sort-header',
  standalone: true,
  templateUrl: './table-sort-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableSortHeaderComponent {
  readonly label = input.required<string>();

  readonly field = input.required<string>();

  readonly activeField = input<string | null>(null);

  readonly direction = input<TableSortDirection | null>(null);

  readonly sortChange = output<TableSortState>();

  readonly isActive = computed(() => this.activeField() === this.field());

  readonly isAscending = computed(
    () => this.isActive() && this.direction() === 'asc'
  );

  readonly isDescending = computed(
    () => this.isActive() && this.direction() === 'desc'
  );

  sort(direction: TableSortDirection): void {
    this.sortChange.emit({
      field: this.field(),
      direction,
    });
  }
}
